// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"47037282","239":"efeac1d4","339":"22f6aa48","429":"69537ae4","494":"098885ed","732":"5b358c02"}[chunkId] + ".chunk.js";
};